<script lang="ts">
	import activityCollection from '$lib/assets/about/activity-collection.webp';
	import Button from '$lib/components/ui/button/button.svelte';
</script>

<div class="flex flex-col md:flex-row items-center py-12 md:py-24 gap-12 md:gap-20">
	<div class="w-full order-2 md:order-1">
		<img
			src={activityCollection}
			alt="Activity Collection"
			class="w-full object-contain rounded-3xl"
		/>
	</div>
	<div class="w-full space-y-6 md:space-y-8 order-1 md:order-2">
		<div
			class="inline-block px-4 py-1.5 bg-white shadow-pl rounded-full font-bold tracking-tight w-fit text-sm"
		>
			What we do
		</div>
		<div class="text-3xl md:text-5xl font-title leading-tight">241,993 verified actions</div>
		<div class="space-y-6">
			<div class="font-display text-left text-slate-600 leading-relaxed">
				To date fans have taken almost 250,000 green actions through Planet League. Each of these
				have involved them doing something good, like eating a veggie meal, ditching the car or
				turning down their thermostat. Planet League is all about action, just like sport.
			</div>
			<Button href="/register" class="w-full md:w-fit">Score now</Button>
		</div>
	</div>
</div>
